import {TimelineLite} from "gsap";
import {Helper} from "@nolimitcity/slot-launcher/bin/utils/Helper";

export class WalkOfShameHelper extends Helper {
    /**
     * This is a new aproach to this problem, with the focus being to really tie the to kinds of animations together to make a "gsap safe"
     * spine animation that actually follows the playhead of any parent timeline and supports other gsap features, such as reverse(), seek() etc.
     * Instead of just starting and stopping animations at different times.
     *
     * Caveat:
     * Does only set a new spine animation at beginning and end of the timeline.
     * So if you try to play the timeline from, say halfway into the animation, and this is not the already set spine animation.
     * It will play the current set spine animation. So playing animations not completely from the start or end (reverse(0)), will probably
     * cause you lots of headache.
     *
     * Easing do work. But be a bit cautious with easing that have overshoot. E.g Back, or Elastic etc.
     * Because we are only animating the play head on the spine animation, there is no "overshoot". You cant play the animation longer than it is.
     *
     * !!! YOU NEED TO SET "autoUpdate = false" on your spine object.
     *
     *
     * @param spine PIXI.spineSpine object
     * @param trackIndex
     * @param animationName
     * @param loop
     * @param animationAlpha
     * @param mixDuration
     * @param resetOnComplete
     * @private
     */
    public static createTimelineForAnimation(spine: PIXI.spine.Spine, trackIndex: number, animationName: string, loop: boolean, animationAlpha: number = 1, mixDuration: number = 0, resetOnComplete: boolean = true): TimelineLite {
        const tl: TimelineLite = new TimelineLite({
            repeat: loop ? -1 : 0
        });

        // trying safe checks for #136
        if (!spine.spineData || !spine.state) {
            return tl;
        }

        const animation: PIXI.spine.core.Animation = spine.spineData.findAnimation(animationName);
        if (!animation) {
            throw new Error(`No animation named ${animationName}`);
        }

        spine.autoUpdate = false;

        const setAnimation: () => void = () => {
            // trying safe check for #136
            if (spine.state) {
                const trackEntry: PIXI.spine.core.TrackEntry = spine.state.setAnimationWith(trackIndex, animation, false);
                trackEntry.alpha = animationAlpha;
                trackEntry.mixDuration = mixDuration;
            }
        };

        const target = {
            playHead: 0,
            spine: spine,
            prevTime: 0
        };

        const updateFunc: () => void = () => {
            // trying safe checks for #136
            if (spine && target) {
                const now = target.playHead;
                spine.update(now - target.prevTime);
                target.prevTime = now;
            }
        };

        tl.add(() => {
            target.prevTime = 0;
            setAnimation();
        });
        tl.fromTo(target, {playHead: 0}, {
            duration: animation.duration,
            playHead: animation.duration,
            onUpdate: updateFunc,
            ease: "none"
        });
        if (resetOnComplete) {
            tl.add(() => {
                target.prevTime = 0;
                setAnimation();
            });
        }
        tl.to(target, {duration: 0.0001}); //Needed so gsap does not skip "setAnimation" during reverse play.
        tl.add(() => {
            target.playHead = animation.duration;
            updateFunc();
        });

        return tl;
    }
}